import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        Button
    } = window.wp.components;

    const { Fragment } = window.wp.element;

    registerBlockType('custom-gutenberg/triple-image', {
        // built-in attributes
        title: 'Triple Image',
        description: 'Triple Image',
        icon: '',
        category: 'containers',
        example: {},

        // custom attributes
        attributes: {
            image1: {
                type: 'string',
                default: ''
            }, 
            alt1: {
                type: 'string',
                default: ''
            },
            image2: {
                type: 'string',
                default: ''
            }, 
            alt2: {
                type: 'string',
                default: ''
            },
            image3: {
                type: 'string',
                default: ''
            }, 
            alt3: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                image1, image2, image3,
                alt1, alt2, alt3,
                classes,
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            const images = [
                { key: 1, image: image1, alt: alt1, label: 'Image 1' },
                { key: 2, image: image2, alt: alt2, label: 'Image 2' },
                { key: 3, image: image3, alt: alt3, label: 'Image 3' }
            ];

            // custom functions

             const onSelectImage = (index, image) => {
                setAttributes({ [`image${index}`]: image.sizes.full.url });
            };

            const onAltChange = (index, alt) => {
                setAttributes({ [`alt${index}`]: alt });
            };

            const onRemoveImage = (index) => {
                setAttributes({ [`image${index}`]: '' });
                setAttributes({ [`alt${index}`]: '' });
            };

            const mediaControls = images.map(({ key, image, alt, label }) => (
                <div key={key} style={{ marginBottom: '20px' }}>
                    <p><strong>{label}</strong></p>
                    <MediaUpload 
                        onSelect={(imageObj) => onSelectImage(key, imageObj)}
                        type="image"
                        value={image}
                        render={({ open }) => (
                            <div>
                                {image && (
                                    <div>
                                        <figure style={{ margin: 0 }}>
                                            <img src={image} style={{ maxWidth: '200px', maxHeight: '150px', objectFit: 'cover' }} />
                                        </figure>
                                            <Button 
                                                onClick={() => onRemoveImage(key)} 
                                                className="button"
                                                style={{ marginRight: '10px' }}
                                            >
                                            Remove
                                        </Button>
                                        <br/>
                                    </div>
                                )}
                                <IconButton
                                    onClick={open}
                                    icon="upload"
                                    className="editor-media-placeholder__button is-button is-default is-large"
                                >
                                    Select {label}
                                </IconButton>
                            </div>
                        )} 
                    />
                    <br />
                    <p><strong>Alt text:</strong></p>
                    <TextControl 
                        value={alt} 
                        onChange={(value) => onAltChange(key, value)}
                    />
                </div>
            ));
                
            return ([
                <Fragment>
                    <InspectorControls style={ { marginBottom: '40px' } }>
                        <PanelBody title={ 'Settings' }>

                             {mediaControls}

                        </PanelBody>
                    </InspectorControls>
                </Fragment>
                ,
                <div className={ "triple-image " + (classes ? ' ' + classes : '') }>
                    <img src={ image1 } alt={ alt1 } className="triple-img-main cover-image" />
                    <div className='triple-image-thumbnail'>
                        <img src={ image2 } alt={ alt2 } className="triple-img cover-image" />
                        <img src={ image3 } alt={ alt3 } className="triple-img cover-image" />
                    </div>
                </div> 
            ]
            );
        },

        save({ attributes }) {

            const {
                image1, image2, image3,
                alt1, alt2, alt3,
                classes,
            } = attributes;

            return (
                <div className={ "triple-image " + (classes ? ' ' + classes : '') }>
                    <img src={ image1 } alt={ alt1 } className="triple-img-main cover-image lozad" />
                    <div className='triple-image-thumbnail'>
                        <img src={ image2 } alt={ alt2 } className="triple-img cover-image lozad" />
                        <img src={ image3 } alt={ alt3 } className="triple-img cover-image lozad" />
                    </div>
                </div>
            );
        },
    });
}